import React from 'react';

import { Chip, Stack } from '@mui/material';

import { LoyaltyPointsBonusConfigV1, PromoLoyaltyMetaConfig, getProductTypeLabel } from '~/services/PromoService';

import Spinner from '../Common/Spinner';

type Props = {
  isPromoMetaLoading: boolean;
  config: LoyaltyPointsBonusConfigV1 | null;
  promoLoyaltyMetaConfig: PromoLoyaltyMetaConfig | null;
  loyaltyBonusApplyMethod: PromoLoyaltyMetaConfig['loyaltyBonusFilterMethods'][number]['key'] | null;
  name?: string;
};

const LoyaltyPointsBonusConfigSummary = ({
  isPromoMetaLoading,
  config,
  promoLoyaltyMetaConfig,
  loyaltyBonusApplyMethod,
}: Props) => {
  if (isPromoMetaLoading) {
    return <Spinner />;
  }

  return (
    <Stack>
      {config?.loyaltyPointsBonusConfigV1
        .sort((a, b) => a.applyOrder - b.applyOrder)
        .map((item) => (
          <Stack key={`${item.id}`}>
            <Chip
              label={`${item.loyaltyPromoKey} - ${getProductTypeLabel(
                item.loyaltyProductType,
                promoLoyaltyMetaConfig,
              )}`}
              color="primary"
              variant="outlined"
            />
          </Stack>
        ))}
    </Stack>
  );
};

export default LoyaltyPointsBonusConfigSummary;
